import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import new_axios_instance from '../axios_instance';
import { dayJS } from '../applicationConf';

export const fetchSerieList = createAsyncThunk(
  'serie/fetchSerieList',
  async ({ idCorso, mese }, thunkAPI) => {
    let serie = [];
    try {
      serie = (
        await new_axios_instance.get(
          `/v1/pianificazione/recupera/serie/${idCorso}/${dayJS(mese).startOf('month').format('YYYY-MM-DD')}/${dayJS(mese).endOf('month').format('YYYY-MM-DD')}`
        )
      ).data;
    } catch (e) {}
    return serie;
  }
);

const serieSlice = createSlice({
  name: 'serie',
  initialState: {
    serieList: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSerieList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSerieList.fulfilled, (state, action) => {
        state.loading = false;
        state.serieList = action.payload;
      })
      .addCase(fetchSerieList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default serieSlice.reducer;
export const serieActions = serieSlice.actions;
